export default {
  actionTypes: {
    info: 'SNACKBAR_INFO_SHOW',
    error: 'SNACKBAR_ERROR_SHOW',
    success: 'SNACKBAR_SUCCESS_SHOW',
    remove: 'SNACKBAR_REMOVE',
  },
  mutationTypes: {
    add: 'SNACKBAR_ADD',
    remove: 'SNACKBAR_REMOVE',
  },
};
